// "Office 365 isn't connected yet" — a STATE, not an error.
//
// 2026-06-09 audit (finding 2.1): before this component, five surfaces
// echoed the API's 412 message verbatim, in error-red, pointing at
// /preferences/email — a route that doesn't exist. Every brand-new
// employee saw a broken-looking app until they happened to find the
// real connect card on /preferences. This component is the single
// friendly rendering of that state: what it means for THIS surface +
// a working "Connect Office 365" link.
//
// Branch with isNotConnectedError(err) in each surface's catch — the
// API signals the state with HTTP 412 + code "not_connected".

import { Link } from "react-router-dom";

import { ApiError } from "../api";

export function isNotConnectedError(err: unknown): boolean {
  return (
    err instanceof ApiError &&
    (err.status === 412 || err.code === "not_connected")
  );
}

const CONTEXT_LINES: Record<NotConnectedContext, string> = {
  email:
    "Connect your account to read and send email from Stewardship OS — it sends from your real Outlook address.",
  send: "Connect your account to send this email — it will go out from your real Outlook address.",
  esign:
    "Signing invitations go out from your Outlook, so as things stand nobody will be emailed — you'll get links to send yourself. Connect it first and the invitations go out on their own.",
  tasks:
    "Connect your account to see and sync your Microsoft To Do tasks here.",
  calendar:
    "Connect your account to see your Outlook calendar here — today plus the next 7 days.",
};

export type NotConnectedContext = "email" | "send" | "esign" | "tasks" | "calendar";

export function NotConnectedNotice({
  context,
  compact = false,
}: {
  context: NotConnectedContext;
  /** Tighter layout for inline spots (composer error slot). */
  compact?: boolean;
}) {
  return (
    <div
      className={
        compact ? "not-connected-notice is-compact" : "not-connected-notice"
      }
    >
      <div className="not-connected-notice__title">
        Office 365 isn't connected yet
      </div>
      <p className="not-connected-notice__line">{CONTEXT_LINES[context]}</p>
      <Link className="btn-primary not-connected-notice__cta" to="/preferences">
        Connect Office 365 →
      </Link>
      {!compact ? (
        <p className="not-connected-notice__hint">
          Takes about a minute — Microsoft will ask you to sign in and
          approve.
        </p>
      ) : null}
    </div>
  );
}
